import { render, staticRenderFns } from "./PDFLoadingPage.vue?vue&type=template&id=2f806768&scoped=true"
import script from "./PDFLoadingPage.vue?vue&type=script&lang=ts"
export * from "./PDFLoadingPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f806768",
  null
  
)

export default component.exports